import styles from "./styles.module.css";
import Item from "./item";
import Add from "./add";
import { ApisValue } from "../../../contexts/apis";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function API({ selected }) {
  const apis = useContext(ApisValue);
  const location = useLocation();
  useEffect(() => {
    const apiId = new URLSearchParams(location.search).get("api");
    if (apiId) {
      console.log(apis);
      const api = apis.find((x) => x.id === apiId);
      console.log(api);
      selected.set(api);
    }
  }, [apis, location.search]);
  return (
    <div className={styles.container}>
      <Add />
      {apis.map((api) => {
        return (
          <Item
            onClick={() => selected.set(api)}
            active={selected.value?.id === api.id}
            key={api.id}
            name={api.name}
          />
        );
      })}
    </div>
  );
}
